const FEATURE_HELP_URLS = {
  agent_bots: 'https://virtuacrm.app/hc/agent-bots',
  agents: 'https://virtuacrm.app/hc/agents',
  audit_logs: 'https://virtuacrm.app/hc/audit-logs',
  campaigns: 'https://virtuacrm.app/hc/campaigns',
  canned_responses: 'https://virtuacrm.app/hc/canned',
  channel_email: 'https://virtuacrm.app/hc/email',
  channel_facebook: 'https://virtuacrm.app/hc/fb',
  custom_attributes: 'https://virtuacrm.app/hc/custom-attributes',
  dashboard_apps: 'https://virtuacrm.app/hc/dashboard-apps',
  help_center: 'https://virtuacrm.app/hc/help-center',
  inboxes: 'https://virtuacrm.app/hc/inboxes',
  integrations: 'https://virtuacrm.app/hc/integrations',
  labels: 'https://virtuacrm.app/hc/labels',
  macros: 'https://virtuacrm.app/hc/macros',
  message_reply_to: 'https://virtuacrm.app/hc/reply-to',
  reports: 'https://virtuacrm.app/hc/reports',
  sla: 'https://virtuacrm.app/hc/sla',
  team_management: 'https://virtuacrm.app/hc/teams',
  webhook: 'https://virtuacrm.app/hc/webhooks',
  billing: 'https://virtuacrm.app/pricing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
